import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { HttpService } from "../../services/HttpService";
import Store from "..";
import { buildParamsUrl } from "../../utils/helpers";

const initialState = {
  citizensList: [],
  searchPerformed: false,
  search: {
    fiscalCode: "",
    surname: "",
  },
  pageIndex: 1,
  pageTotal: 0,
  itemsPerPage: Number(process.env.REACT_APP_PAGE_LIST) || 5,
  order: "name",
  orderAs: "asc",
  editCitizen: "",
  apiError: "",
};

/**
 * fetch citizen data by search value fiscal-code or name or surname
 */
export const fetchCitizensBySearchParams = () => async (dispatch: any) => {
  try {
    const order = Store.getState().citizens.order;
    const orderAs = Store.getState().citizens.orderAs;
    const search = Store.getState().citizens.search;
    const itemsPerPage = Store.getState().citizens.itemsPerPage;
    const pageIndex = Store.getState().citizens.pageIndex;

    const params = buildParamsUrl({
      ...search,
      order,
      orderAs,
      itemsPerPage,
      page: pageIndex,
    });

    const list = await HttpService.get(
      `${process.env.REACT_APP_API}/t4event/api/v01/guest/citizens?${params}`
    );
    if (list.data) {
      dispatch(updateCitizensList(list.data.result));
      dispatch(
        updatePageTotal(Math.ceil(Number(list.data.totalItems) / itemsPerPage))
      );
      dispatch(updateSearchPerformed(true));
    }
  } catch (e) {
    console.log("search Citizens:", e);
  }
};

/**
 * update pagination number
 */
export const updatePageIndex = (pageIndex: string) => async (dispatch: any) => {
  try {
    dispatch(updatePage(pageIndex));
  } catch (e) {
    console.log("update search value:", e);
  }
};

/**
 * store search input value
 */
export const updateSearchValue = (params: any) => async (dispatch: any) => {
  try {
    dispatch(updateSearch(params));
    dispatch(updatePage(1));
  } catch (e) {
    console.log("update search params:", e);
  }
};

/**
 * save new citizen
 */
export const addCitizen = (data: any) => async (dispatch: any) => {
  try {
    const result = await HttpService.post(
      `${process.env.REACT_APP_API}/t4event/api/v01/guest/citizen`,
      data
    );

    if (result.data) {
      dispatch(
        updateSearchValue({
          fiscalCode: data.fiscalcode,
          surname: "",
        })
      );
      dispatch(fetchCitizensBySearchParams());
      return result.data.result._id;
    }
  } catch (e: any) {
    dispatch(updateServerError(e.response.data.result));
  }
};

/**
 * update  citizen
 */
export const updateCitizen = (id: any, data: any) => async (dispatch: any) => {
  try {
    const result = await HttpService.put(
      `${process.env.REACT_APP_API}/t4event/api/v01/guest/${id}/citizen`,
      data
    );

    if (result.data) {
      return result.data.result._id;
    }
  } catch (e: any) {
    dispatch(updateServerError(e.response.data.result));
  }
};

/**
 * Get citizen by Id
 */
export const getCitizenById = (id: string) => async (dispatch: any) => {
  try {
    const list = await HttpService.get(
      `${process.env.REACT_APP_API}/t4event/api/v01/guest/${id}/view`
    );

    if (list.data) {
      dispatch(updateEditCitizenData(list.data.result.guestDetail));
      return list.data.result.guestDetail;
    }
  } catch (e) {
    console.log("update search value:", e);
  }
};

const citizensReducer = createSlice({
  name: "citizens",
  initialState,
  reducers: {
    updateCitizensList(state, action: PayloadAction<any>) {
      state.citizensList = action.payload;
    },
    updateSearch(state, action: PayloadAction<any>) {
      state.search = action.payload;
    },
    updateSearchPerformed(state, action: PayloadAction<any>) {
      state.searchPerformed = action.payload;
    },
    updateOrder(state, action: PayloadAction<any>) {
      state.order = action.payload;
    },
    updateOrderAs(state, action: PayloadAction<any>) {
      state.orderAs = action.payload;
    },
    updatePage(state, action: PayloadAction<any>) {
      state.pageIndex = action.payload;
    },
    updatePageTotal(state, action: PayloadAction<any>) {
      state.pageTotal = action.payload;
    },
    updateEditCitizenData(state, action: PayloadAction<any>) {
      state.editCitizen = action.payload;
    },
    updateServerError(state, action: PayloadAction<any>) {
      state.apiError = action.payload;
    },
  },
});

export const {
  updateCitizensList,
  updateSearch,
  updateSearchPerformed,
  updateOrder,
  updateOrderAs,
  updatePage,
  updatePageTotal,
  updateEditCitizenData,
  updateServerError,
} = citizensReducer.actions;

export default citizensReducer.reducer;
